import { render, staticRenderFns } from "./ContentItemSettingPlaceholder.vue?vue&type=template&id=207ad9b9&scoped=true"
import script from "./ContentItemSettingPlaceholder.vue?vue&type=script&lang=js"
export * from "./ContentItemSettingPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./ContentItemSettingPlaceholder.vue?vue&type=style&index=0&id=207ad9b9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207ad9b9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('207ad9b9')) {
      api.createRecord('207ad9b9', component.options)
    } else {
      api.reload('207ad9b9', component.options)
    }
    module.hot.accept("./ContentItemSettingPlaceholder.vue?vue&type=template&id=207ad9b9&scoped=true", function () {
      api.rerender('207ad9b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/content/ContentItemSettingPlaceholder.vue"
export default component.exports